import { render } from "./significance_ploat.vue?vue&type=template&id=c7deab1c&scoped=true"
import script from "./significance_ploat.vue?vue&type=script&lang=js"
export * from "./significance_ploat.vue?vue&type=script&lang=js"

import "./significance_ploat.vue?vue&type=style&index=0&id=c7deab1c&lang=css"
import "./significance_ploat.vue?vue&type=style&index=1&id=c7deab1c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7deab1c"]])

export default __exports__